var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiles = function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212221",
    d: "M11.25 0h-9C1.013 0 0 1.035 0 2.3v18.4C0 21.965 1.013 23 2.25 23h13.5c1.238 0 2.25-1.035 2.25-2.3V6.9zm2.25 13.8h-9v-2.3h9zm-2.25 4.6H4.5v-2.3h6.75zM10.125 8.05V1.725l6.188 6.325z"
  })));
};
export default SvgFiles;